import { Typography, Card, CardContent } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    activeCards: {
        fontWeight: '700!important'
    },
    card: {
        backgroundColor: 'white!important',
        minWidth: '10em',
        fontWeight: '700!important',
        marginTop: 20
    }
});

export default function ActiveCards({ activeCards }) {
    const classes = useStyles();

    return (
        <Card className={`${classes.card} transactions-titles__last`}>
            <CardContent>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    TOTAL ACTIVE CARDS
                </Typography>
                <Typography variant="h5" component="div" className={classes.activeCards}>
                    {activeCards}
                </Typography>
            </CardContent>
        </Card>
    );
}
